import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { AuthGuard } from './auth.guard';
import { Routes, RouterModule } from '@angular/router';
import { AuthComponentGuard } from './auth-component.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NavigationComponent } from './navigation/navigation.component';

const routes: Routes = [
  { path: '', component: LoginComponent, canActivate: [AuthGuard] },
  { path: '', component: NavigationComponent },

  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthComponentGuard], data: { expectedRole: ['1'] } },
  { path: 'petrol-tracker', loadChildren: './petrol-tracker/petrol-tracker-module/petrol-tracker.module#PetrolTrackerModule' },

  { path: 'distribution-list/:id/:type', loadChildren: './distribution/distribution-module/distribution.module#DistributionModule' },

  { path: 'order-list', loadChildren: './order/primary-order-module/primary-order.module#PrimaryOrderModule' },

  { path: 'segment-list', loadChildren: './segment-list/segment-module/segment.module#SegmentModule' },
  { path: 'subcategory', loadChildren: './subcategory/subcategory-module/subcategory.module#SubcategoryModule' },
  { path: 'product-list', loadChildren: './product/product-module/product.module#ProductModule' },
  { path: 'user-designation', loadChildren: './userdesignation/userdesignation-module/userdesignation.module#UserdesignationModule' },
  { path: 'sale-user-list', loadChildren: './user/user-module/user.module#UserModule' },
  { path: 'hr-recruitment', loadChildren: './hr-recruitment/hr-recruitment.module#HrRecruitmentModule' },
  { path: 'performance', loadChildren: './performance/performance.module#PerformanceModule' },
  { path: 'it-resource', loadChildren: './it-resource/it-resource.module#ItResourceModule' },
  { path: 'apt-employee-list', loadChildren: './apt-employee/apt-employee.module#AptEmployeeModule' },
  { path: 'salary-calculator', loadChildren: './salary-calculator/salary-calculator.module#SalaryCalculatorModule' },
  { path: 'employee-attendance', loadChildren: './employee-attendance/employee-attendance.module#EmployeeAttendanceModule' },
  { path: 'employee-attendance-entry', loadChildren: './employee-attendance-entry/employee-attendance-entry.module#EmployeeAttendanceEntryModule' },
  { path: 'employee-pay-slip', loadChildren: './employee-pay-slip/employee-pay-slip.module#EmployeePaySlipModule' },
  { path: 'plant-employee', loadChildren: './plant-employee/plant-employee.module#PlantEmployeeModule' },
  { path: 'attendance-verification', loadChildren: './attendance-verification/attendance-verification.module#AttendanceVerificationModule' },
  { path: 'resignation', loadChildren: './resignation/resignation.module#ResignationModule' },
  { path: 'user-vacancy', loadChildren: './user-vacancy/user-vacancy.module#UserVacancyModule' },
  { path: 'discount-master', loadChildren: './discount/discount-module/discount-module.module#DiscountModuleModule' },
  { path: 'otp-list', loadChildren: './master/otp-list-module/otp-list.module#OtpListModule' },
  { path: 'visitor', loadChildren: './visitor/visitor.module#VisitorModule' },
  { path: 'gate-pass', loadChildren: './gate-pass/gate-pass.module#GatePassModule' },
  { path: 'patrol', loadChildren: './patrol/patrol.module#PatrolModule' },
  { path: 'inv-mgmt', loadChildren: './inv-mgmt/inv-mgmt-module/inv-mgmt.module#InvMgmtModule' },
  { path: 'ui-kit', loadChildren: './ui-kit/ui-kit.module#UiKitModule' },
  { path: 'induction', loadChildren: './induction/induction.module#InductionModule' },
  // Public — candidate joins a video interview from an emailed link, no login.
  { path: 'interview/:token', loadChildren: './interview/interview.module#InterviewModule' },
  { path: 'security', loadChildren: './security-portal/security-portal.module#SecurityPortalModule' },
  { path: 'security-attendance', loadChildren: './security-attendance/security-attendance.module#SecurityAttendanceModule' },
  { path: 'shortcut', loadChildren: './shortcut/shortcut.module#ShortcutModule' },
];


@NgModule({
  imports: [
    RouterModule.forRoot(routes),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
